<template>
  <div id="mockList" class="container">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <div class="mx-auto center pt-8 w-100">
          <h2 class="bold">Resultado - Simulado CFP®</h2>
        </div>
      </v-layout>
    </v-container>
    <div v-if="result.type">
      <event-result
        :disabled="!disabled"
        :score="result.right_answers"
        :modules="result.modules"
        :totalQuestions="result.total_questions"
        :type="result.type"
        :logs="result.logs"
      />
    </div>
    <div v-else class="text-center mt-4">
      <h4>Resultado não encontrado</h4>
    </div>
  </div>
</template>
<script>
import MockService from "@/services/mocks.service";
import EventResult from "../../components/quiz/EventResult";

export default {
  components: {
    MockService,
    EventResult,
  },
  data() {
    return {
      dialog: true,
      loading: false,
      result: {
        type: null,
      },
      disabled: false,
    };
  },
  created() {
    this.loading = true;
    MockService.generateResult(
      this.$route.params.user,
      this.$route.params.result,
    ).then((resp) => {
      this.result = resp;
      this.loading = false;
      this.disabled = true;
    });
  },
};
</script>
